import { useCallback, useEffect, useState } from 'react';
import en from './languages/en.json';

export const localeModules = {
  no: () => import(/* webpackChunkName: "Locale-NO" */ './languages/no.json'),
  zh: () => import(/* webpackChunkName: "Locale-ZH" */ './languages/zh.json'),
  fr: () => import(/* webpackChunkName: "Locale-FR" */ './languages/fr.json'),
  dk: () => import(/* webpackChunkName: "Locale-DK" */ './languages/dk.json'),
};

const emptyLocale = () => Promise.resolve({ default: {} });

const useLocaleMessages = locale => {
  const [localeMessages, setLocaleMessages] = useState(null);
  const [error, setError] = useState(false);
  const loadLocale = useCallback(async () => {
    try {
      const langLocale = await (localeModules[locale] || emptyLocale)();
      setLocaleMessages({ ...en, ...langLocale.default });
    } catch (_e) {
      setError(true);
    }
    // biome-ignore lint/correctness/useExhaustiveDependencies: locale doesn't always change
  }, [locale]);
  useEffect(() => {
    loadLocale();
  }, [loadLocale]);
  return [localeMessages, error];
};

export default useLocaleMessages;
